// import Icon from "../components/ui/Icon";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import CategoryIcon from "../components/CatIconMapper";
import InstitutionCard from "../components/InstitutionCard";
import OtherSiteIdentity from "../components/OtherSiteIdentity";
import { useCategories } from "../features/home/hooks/useCategories";
import { useHomeLayout } from "../features/layout/hooks/useHomeLayout";
// import {
//   Sheet,
//   SheetClose,
//   SheetContent,
//   SheetHeader,
//   SheetTrigger,
// } from "../components/ui/sheet";

export default function Services() {
  const { id } = useParams();
  const categoryId = id ? Number(id) : undefined;
  // const navigate = useNavigate();
  const { data: items = [], isLoading } = useCategories({
    model: "projects",
    category_id: categoryId,
  });
  const { setHideHeaderOnScroll } = useOutletContext() as {
    setHideHeaderOnScroll: (v: boolean) => void;
  };
  const { data } = useHomeLayout();
  // const [open, setOpen] = useState(false);
  const categories = data?.categories ?? [];
  const activeCategory = categories.find((c) => String(c.id) === String(id));
  const [isScrolled, setIsScrolled] = useState(false);

  // const handleSelectCategory = (catId: number) => {
  //   navigate(`/services/${catId}`);
  //   setOpen(false);
  // };

  useEffect(() => {
    const handleScroll = () => {
      const isMobile = window.innerWidth < 1280;

      if (!isMobile) {
        setIsScrolled(false);
        setHideHeaderOnScroll(false);
        return;
      }

      const scrolled = window.scrollY > 40;

      setIsScrolled(scrolled);
      setHideHeaderOnScroll(scrolled);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [setHideHeaderOnScroll]);

  return (
    <div className="w-full min-h-screen bg-green-01 pb-4 xl:pb-12">
      <OtherSiteIdentity categories={categories} activeId={id} />

      {/* UI هدر دسته‌بندی */}
      {activeCategory && (
        <div className="relative mt-10 xl:mt-[95px] h-[170px] xl:h-[190px] px-4">
          <div
            className={[
              "z-30 transition-all duration-300 ease-in-out",
              isScrolled ? "fixed top-0 left-0 right-0" : "relative",
            ].join(" ")}
          >
            <div
              className={[
                "relative mx-auto transition-all duration-300 ease-in-out text-green-05",
                isScrolled
                  ? "w-full xl:w-[65%] h-[72px] bg-green-02/25 flex items-center justify-start gap-x-2.5 px-2.5 shadow-sm backdrop-blur"
                  : "flex flex-col items-center justify-start gap-2.5",
              ].join(" ")}
            >
              <CategoryIcon
                id={activeCategory.id}
                className={`text-[#8BB174] transition-all duration-300 ${
                  isScrolled ? "size-4 xl:size-10" : "size-[74px] xl:size-28"
                }`}
              />

              <div
                className={[
                  "transition-all duration-300 ease-in-out",
                  isScrolled
                    ? "flex flex-col items-start leading-tight"
                    : "flex flex-col items-center",
                ].join(" ")}
              >
                {isScrolled && (
                  <span className="text-[10px] font-medium text-green-04">
                    کتابخانه های تخصصی
                  </span>
                )}

                <span
                  className={[
                    "font-extrabold text-accent-04 transition-all duration-300 ease-in-out",
                    isScrolled ? "text-sm" : "text-[20px]",
                  ].join(" ")}
                >
                  {activeCategory.name}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full xl:w-[72%] place-self-center px-4 transition-all duration-300 mt-6"
        dir="rtl"
      >
        {isLoading ? (
          <div className="col-span-full flex items-center justify-center h-64">
            <div className="w-6 h-6 border-2 border-green-05 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : items.length === 0 ? (
          <div className="col-span-full flex items-center justify-center h-64 text-green-04 font-estedad">
            موردی یافت نشد
          </div>
        ) : (
          items.map((item: any, index: number) => (
            <InstitutionCard
              key={`${item.id || "service-project"}-${index}`}
              project={item}
              index={index}
              isActive={false}
              searchQuery=""
              onClick={() => {}}
            />
          ))
        )}
      </div>
    </div>
  );
}
